import { Cache } from '../client-cache/client-cache';

Cache.clearCourses();
